module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "component-backoffice-card"
  }, [_c('table', [_vm._m(0), _c('tbody', [_vm._l((_vm.item.time_rates), function(time) {
    return _c('tr', [_c('td', [_vm._v(_vm._s(time.rate.id))]), _c('td', [_vm._v(_vm._s(time.rate.name))]), _c('td', [_vm._v("Time")]), _c('td', [_c('span', {
      staticClass: "badge success"
    }, [_vm._v(_vm._s(time.count))])])])
  }), _vm._l((_vm.item.distance_rates), function(distance) {
    return _c('tr', [_c('td', [_vm._v(_vm._s(distance.rate.id))]), _c('td', [_vm._v(_vm._s(distance.rate.name))]), _c('td', [_vm._v("Distance")]), _c('td', [_c('span', {
      staticClass: "badge success"
    }, [_vm._v(_vm._s(distance.count))])])])
  })], 2)])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('th', [_vm._v("Id")]), _c('th', [_vm._v("Name")]), _c('th', [_vm._v("Type")]), _c('th', [_vm._v("Count")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-58fa188d!./~/vue-loader/lib/template-loader.js?raw&engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/backoffice/AppliedRates.vue
// module id = 2501
// module chunks = 1